import { DwAction, DwActionHandler, DwActionResult, DwActionType, DwMetaDataGridActionState, DwModalService, DwSecurityEmulationService } from "@devwareapps/devware-cap";
import { AppPermissions } from "../../../meta-data/app-permissions.enum";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { FlightSchoolEntity } from "../../../meta-data/app-meta-data.service";
import { AdminManagerService } from "../services/admin-manager.service";
import { map } from "rxjs/operators";

@DwAction({
    keyName: 'school-select-grid-action',
    display: 'School Select',
    actionType: DwActionType.gridRowAction,
    isGlobal: true,
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: false,
        permissionMeaning: AppPermissions.lMSAllSchoolsAdmin,
    },
    defaultMenuConfig: {
        useParentDisplay: false,
        menuDisplay: 'Switch to School'
    }
})
@Injectable()
export class SchoolSelectGridAction implements DwActionHandler {
    constructor(private adminManagerService: AdminManagerService) { }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {
        const result: DwActionResult = {
            success: false,
        }

        const flightSchool: FlightSchoolEntity = actionState.data;

        if (!flightSchool?.FlightSchoolId) {
            result.message = 'Flight School was not passed in';
            return of(result);
        }

        return this.adminManagerService.setCurrentFlightSchool(flightSchool.FlightSchoolId)
            .pipe(map(user => {
                result.success = true;

                return result;
            }));
    }

}